"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CancelWebsiteSubscriptionSalesforceSchema = void 0;
exports.CancelWebsiteSubscriptionSalesforceSchema = {
    $schema: 'http://json-schema.org/draft-07/schema#',
    properties: {
        sonosId: {
            type: 'string',
        },
        eventDate: {
            type: 'string',
            minLength: 5,
        },
        subscriptionId: {
            type: 'string',
        },
        subscriptionEndDate: {
            type: 'string',
            minLength: 10,
        },
        transactionId: {
            type: 'string',
        },
        messageId: {
            type: 'string',
        },
        eventType: {
            type: 'string',
        },
        cancellationReason: {
            type: 'string',
        },
        orderDateOverride: {
            type: 'string',
        },
        accountNumber: {
            type: 'string',
        },
        cancellationPolicy: {
            type: 'string',
        },
        cancellationReasonZuora: {
            type: 'string',
        },
        cancellationEffectiveDate: {
            type: 'string',
        },
    },
    required: ['sonosId', 'eventDate', 'subscriptionId', 'subscriptionEndDate', 'transactionId', 'messageId', 'eventType'],
    type: 'object',
};
//# sourceMappingURL=data:application/json;base64,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